import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import LocaleStrings from "Languages";
import { isEmpty } from "BaseFunctions";
import {
  ComposedChart,
  Line,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  PieChart,
  Pie,
  Cell,
  Sector,
  Label,
  LabelList,
} from "recharts";
import {
  scaleOrdinal,
  schemeCategory10,
  schemeCategory20,
  schemeCategory20b,
  schemeCategory20c,
} from "d3-scale";
import { isTablet } from "Constants";
var randomColor = require("randomcolor");

class PaiCharSocialfeedContaint extends Component {
  constructor(props) {
    super(props);
    var randomColors = this.generateColors(); //[...scaleOrdinal(schemeCategory20).range(),...scaleOrdinal(schemeCategory20b).range(),...scaleOrdinal(schemeCategory20c).range()];
    this.state = { colors: randomColors };
  }

  generateColors = () => {
    var randomColors = []; //[...scaleOrdinal(schemeCategory20).range(),...scaleOrdinal(schemeCategory20b).range(),...scaleOrdinal(schemeCategory20c).range()];
    for (var i = 0; i < 200; i++) {
      randomColors.push(randomColor());
    }
    randomColors = [
      ...randomColors,
      ...randomColor({ hue: "red", count: 50 }),
      ...randomColor({ hue: "orange", count: 50 }),
      ...randomColor({ hue: "blue", count: 50 }),
      ...randomColor({ hue: "green", count: 50 }),
      randomColor({ hue: "yellow", count: 50 }),
      ...randomColor({ hue: "purple", count: 50 }),
      ...randomColor({ hue: "pink", count: 50 }),
      ...randomColor({ luminosity: "dark", count: 50 }),
    ];
    randomColors = _.shuffle(randomColors);
    randomColors = _.shuffle(randomColors);
    randomColors = _.shuffle(randomColors);

    return randomColors;
  };

  render() {
    var pieVersion = [];
    var chartdata = [];
    chartdata = this.props.socialfeedPostypePaichartData;

    if (chartdata) {
      pieVersion = chartdata;
    }

    return (
      <div className="row">
        <div className="col-md-12 col-xs-12 col-lg-12">
          <div className="panel panel-default dashboard-panel">
            <div
              className="panel-heading dashboard-panel-head"
              style={{ borderColor: "white" }}
            >
              <div className="tableHeaderSection">
                <p className="analytics-chart-header">
                  {LocaleStrings.analytics_socialfeeds_chart_1st_header}
                </p>
                <p className="analytics-chart-subheader">
                  {LocaleStrings.analytics_socialfeeds_chart_1st_subheader}
                </p>
              </div>
            </div>
            {!isEmpty(pieVersion) ? (
              <div className="panel-body dashboard-session-graph-panel ">
                <div className="device-percentage">
                  <span style={{ fontSize: 24 }}>{pieVersion.length}</span>
                  <span style={{ fontSize: 14 }}> Posting Types</span>
                </div>
                <PieChart width={500} height={220}>
                  <Pie
                    data={pieVersion}
                    outerRadius={80}
                    innerRadius={50}
                    dataKey="value"
                    labelLine={false}
                    legendType="circle"
                  >
                    {pieVersion.map((entry, index) => (
                      <Cell
                        key={`slice-${index}`}
                        fill={this.state.colors[index]}
                      />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend
                    iconSize={5}
                    wrapperStyle={{
                      top: 30,
                      height: "280px",
                      overflow: "auto",
                      width: "220px",
                      fontSize: 11,
                    }}
                    layout="vertical"
                    verticalAlign="middle"
                    align="right"
                  />
                </PieChart>
              </div>
            ) : (
              <div className="nouser-info">
                <span>
                  {LocaleStrings.analytics_text_no_session_recorded_yet}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    socialfeedPostypePaichartData: state.socialfeedPostypePaichartData,
  };
}

export default connect(mapStateToProps)(PaiCharSocialfeedContaint);
